exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-33OnR{margin-bottom:40px}.container-33OnR:last-child{margin-bottom:0}.header-EDyE5{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;width:100%}.header-EDyE5>div{margin-bottom:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.arrow-f1Yje{margin-left:10px;margin-right:-10px;width:20px !important;font-size:24px !important;-webkit-transition:.3s;transition:.3s;position:relative;top:2px}.arrow-f1Yje.reverse-2jHVC{-webkit-transform:rotateX(180deg);transform:rotateX(180deg);-webkit-transition:.3s;transition:.3s}.arrow-f1Yje.left-1i9ol{margin-left:0}.arrow-f1Yje.left-1i9ol,.arrow-f1Yje.right-3YfzR{margin-right:10px}", ""]);

// exports
exports.locals = {
	"container": "container-33OnR",
	"header": "header-EDyE5",
	"arrow": "arrow-f1Yje",
	"reverse": "reverse-2jHVC",
	"left": "left-1i9ol",
	"right": "right-3YfzR"
};